/* eslint-disable import/no-unresolved */

import React, { useEffect, useRef, useContext } from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { HrLabel, HrRed, HrParagraph, HrFlexContainer } from '@components/styles/hr-styles';
import { ErrorMessage } from '@hookform/error-message';
import { get } from 'lodash';
import { SelectCreatable } from './select-creatable';
import { DisplaySettingsContext } from '../../../postulation_form/store/display-settings';

export const SelectCreatableForm = ({
  formState,
  validate,
  control,
  id,
  inputId,
  name,
  data,
  title,
  isLoading,
  isDisabled,
  errorTop,
  errorBottom
}) => {
  const [t] = useTranslation();
  const validateRegister = {};
  const { errors } = formState;
  const refCurrent = useRef(null);
  if (validate.required) {
    validateRegister.required = t(`general.error.obligatoryField`);
  }

  const err = get(errors, inputId);
  useEffect(() => {
    if (err) {
      refCurrent.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      refCurrent.current?.focus();
    }
  }, [err]);

  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

  return (
    <HrFlexContainer flexDirection='column' gap='8px' alignItems='flex-end' ref={refCurrent}>
      <HrFlexContainer justifyContent='space-between'>
        {title && (
          <HrLabel fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''} htmlFor={inputId} isRequired={validate.required} userSelect='none'>
            {title}
          </HrLabel>
        )}
        {err && errorTop && (
          <ErrorMessage
            errors={errors}
            name={inputId}
            render={({ message }) => <HrParagraph color={HrRed}>{message}</HrParagraph>}
          />
        )}
      </HrFlexContainer>
      <Controller
        control={control}
        name={name}
        defaultValue={null}
        rules={validateRegister}
        render={({ field }) => (
          <SelectCreatable
            color={darkMode ? 'white' : ''}
            selected={field.value}
            inputRef={field.ref}
            data={data}
            name={name}
            id={inputId}
            inputId={inputId}
            isLoading={isLoading}
            isDisabled={isDisabled}
            onChange={field.onChange}
            formState={formState}
          />
        )}
      />
      {err && errorBottom && (
        <ErrorMessage
          errors={errors}
          name={inputId}
          render={({ message }) => <HrParagraph color={HrRed}>{message}</HrParagraph>}
        />
      )}
    </HrFlexContainer>
  );
};

SelectCreatableForm.propTypes = {
  formState: PropTypes.object,
  validate: PropTypes.object,
  id: PropTypes.string,
  inputId: PropTypes.string,
  name: PropTypes.string,
  data: PropTypes.array,
  title: PropTypes.string
};

SelectCreatableForm.defaultProps = {
  formState: { errors: {} },
  validate: {},
  id: '',
  inputId: '',
  name: '',
  data: []
};
